export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '企业管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.template': '模板示例',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '仪表板',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人中心',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  // 人才
  'menu.talents': '人才',
  'menu.talents.allTalents': '全部人才',
  'menu.talents.myTalents': '我创建的人才',
  'menu.talents.privateTalents': '我私池的人才',
  'menu.talents.publicTalents': '公海人才',
  'menu.talents.talentCollection': '收藏夹',
  'menu.talents.__talentCollectionAction': '人才收藏夹',
  'menu.talents.createTalent': '创建人才',
  'menu.talents.editTalent': '编辑人才',
  'menu.talents.talentDetail': '人才详情',
  'menu.talents.talentTests': '人才测试',
  'menu.talent-create': '创建人才',
  'menu.talent-detail': '人才详情',
  'menu.talent-test-create': '创建测试',
  // 职位
  'menu.jobs': '职位',
  'menu.jobs.allJobs': '全部职位',
  'menu.jobs.myJobs': '我创建的职位',
  'menu.jobs.createJob': '创建职位',
  'menu.jobs.editJob': '编辑职位',
  'menu.jobs.jobDetail': '职位详情',
  // 客户
  'menu.clients': '客户',
  'menu.clients.allClients': '全部客户',
  'menu.clients.myClients': '我创建的客户',
  'menu.clients.privateClients': '我私池的客户',
  'menu.clients.publicClients': '公海客户',
  'menu.clients.clientCollection': '收藏夹',
  'menu.clients.__clientCollectionAction': '客户收藏夹',
  'menu.clients.createClient': '创建客户',
  'menu.clients.editClient': '编辑客户',
  'menu.clients.clientDetail': '客户详情',
  // 团队管理
  'menu.teamManagement': '团队管理',
  'menu.teamManagement.consultantPrivatePools': '顾问私池管理',
  // 项目
  'menu.projects': '项目',
  'menu.projects.allProjects': '全部项目',
  'menu.projects.myProjects': '我创建的项目',
  'menu.projects.recommendedProjects': '我推荐的项目',
  'menu.projects.responsibleProjects': '我负责的项目',
  'menu.projects.projectCollection': '收藏夹项目',
  'menu.projects.__projectCollectionAction': '项目收藏夹',
  'menu.projects.createProject': '创建项目',
  'menu.projects.editProject': '编辑项目',
  'menu.projects.projectDetail': '项目详情',
  // 面试
  'menu.interviews': '面试',
  'menu.interviews.allInterviews': '全部面试',
  'menu.interviews.myInterviews': '我创建的面试',
  'menu.interviews.interviewsList': '面试列表',
  'menu.interviews.interviewsList.all': '全部面试',
  'menu.interviews.interviewsList.my': '我创建的面试',
  'menu.interviews.interviewExecution': '面试执行',
  // 报表
  'menu.reports': '报表',
  'menu.reports.performanceReports': '业绩统计',
  'menu.reports.businessReports': '业务统计',
  // 工作报告
  'menu.workReports': '工作报告',
  'menu.workReports.dailyReports': '日报',
  'menu.workReports.dailyReports.dailyReportsAll': '全部日报',
  'menu.workReports.dailyReports.dailyReportToday': '今日日报',
  'menu.workReports.weeklyReports': '周报',
  'menu.workReports.weeklyReports.weeklyReportsAll': '全部周报',
  'menu.workReports.weeklyReports.weeklyReportThisWeek': '本周周报',
  'menu.workReports.monthlyReports': '月报',
  'menu.workReports.monthlyReports.monthlyReportsAll': '全部月报',
  'menu.workReports.monthlyReports.monthlyReportThisMonth': '本月月报',
  'menu.workReports.yearlyReports': '年报',
  'menu.workReports.yearlyReports.yearlyReportsAll': '全部年报',
  'menu.workReports.yearlyReports.yearlyReportThisYear': '本年年报',
  'menu.generate-recommendation-report': '生成推荐报告',
  // 数据分析
  'menu.analytics': '数据分析',
  'menu.analytics.analyticsOverview': '数据概览',
  'menu.analytics.analyticsClients': '客户分析',
  'menu.analytics.analyticsProjects': '项目分析',
  'menu.analytics.analyticsTalents': '人才分析',
  'menu.analytics.analyticsWork': '工作分析',
  'menu.analytics.analyticsJobs': '职位分析',
  // 轻猎头
  'menu.lightHunter': '轻猎头',
  'menu.lightHunter.lightHunterDashboard': '工作台',
  'menu.lightHunter.lightHunterEnterprises': '企业管理',
  'menu.lightHunter.lightHunterEnterprises.lightHunterEnterpriseRelease':
    '企业释放管理',
  'menu.lightHunter.lightHunterEnterprises.lightHunterEnterpriseFollow':
    '企业跟进管理',
  'menu.lightHunter.lightHunterEnterprises.lightHunterEnterpriseJobs':
    '岗位管理',
  'menu.lightHunter.lightHunterTalents': '人才库',
  'menu.lightHunter.lightHunterTasks': '任务中心',
  'menu.lightHunter.lightHunterRecommendations': '候选人',
  'menu.lightHunter.lightHunterCandidates': '候选人',
  'menu.lightHunter.lightHunterTaskDetail': '任务详情',
  'menu.lightHunter.lightHunterChat': '消息',
  'menu.lightHunter.lightHunterMembers': '成员与认证',
  'menu.lightHunter.lightHunterMembers.lightHunterMemberUsers': '管理成员',
  'menu.lightHunter.lightHunterMembers.lightHunterHunterDirectory':
    '轻猎头管理',
  'menu.lightHunter.lightHunterMembers.lightHunterHunterDetail': '轻猎头详情',
  'menu.lightHunter.lightHunterMembers.lightHunterBusinessTeams': '业务团队',
  'menu.lightHunter.lightHunterMembers.lightHunterRealNameVerifications':
    '实名认证',
  'menu.lightHunter.lightHunterAnalytics': '数据分析',
  'menu.lightHunter.lightHunterVerifications': '实名认证审核',
  'menu.lightHunter.lightHunterFinance': '结算与提现',
  'menu.lightHunter.lightHunterPoints': '积分管理',
  'menu.lightHunter.lightHunterRewardRules': '积分规则',
  'menu.lightHunter.lightHunterWithdrawals': '提现管理',
  // 个人设置
  'menu.settings': '个人设置',
  'menu.settings.settingsProfile': '个人信息',
  'menu.settings.settingsReportTemplates': '报告模板',
  'menu.settings.settingsMessages': '消息中心',
  // 内容管理
  'menu.content': '内容管理',
  'menu.articles': '文章',
  'menu.articles.allArticles': '全部文章',
  'menu.articles.articleDetail': '文章详情',
  'menu.topics': '话题管理',
  'menu.topic-detail': '话题详情',
  'menu.questions': '问师傅',
  'menu.questions.allQuestions': '全部问题',
  'menu.questions.myQuestions': '我创建的问题',
  'menu.questions.myAnswers': '我的回答',
  'menu.questions.questionDetail': '问题详情',
  'menu.questions.questionCategories': '分类管理',
  // 企业管理
  'menu.data-dictionaries': '数据字典',
  'menu.dataDictionaries': '数据字典',
  'menu.companies': '公司管理',
  // 其他
  'menu.feed': '动态',
  'menu.notifications': '通知',
  'menu.search': '搜索',
  'menu.interview-execution': '面试执行',
  'menu.my-answers': '我的答案',
  'menu.personal-settings-messages': '消息设置',
  'menu.personal-settings-report-templates': '报告模板',
  'menu.generateRecommendationReport': '生成推荐报告',
  // 动态菜单动作（兼容旧 key）
  'menu.__talentCollectionAction': '人才收藏夹',
  'menu.__clientCollectionAction': '客户收藏夹',
  'menu.__projectCollectionAction': '项目收藏夹',
};
